var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "chat-alert-left-4",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M20.89,7.42h0A10,10,0,0,0,7.42,3.11,10,10,0,0,0,3,16.26l-.62,3.06a1.8,1.8,0,0,0,0,.8,2,2,0,0,0,2.36,1.56l3.06-.63a9.78,9.78,0,0,0,2.61.81A9.19,9.19,0,0,0,12,22,10,10,0,0,0,20.89,7.42Z",
    style: {
      fill: "#00000000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M12,14a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,14Zm0-2a1,1,0,0,0,1-1V8a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12Z",
    style: {
      fill: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.4ba0e74f2ba8db8db9096fe72ab2838c.svg";
export { ForwardRef as ReactComponent };